import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer,Highchartscomponent, Button} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';
import Highcharts from 'highcharts';


Highcharts.setOptions({
colors: ['#660066', '#800080', '#be29ec', '#d896ff', '#efbbff',
    '#FDB9C8', '#DE6FA1', '#FB607F', '#DE3163', '#F81894']
});





const challenges = {
  chart: {
        type: 'column'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Fundraising', 'Finding qualified talent','Hiring (in general)', 'Growth', 'Hiring (in general)','Validating product / market fit', 'other', 'Not sure / prefer not to respond']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'normal'
        }
    },
    series: [ {
        name: 'Single greatest challenge',
        data: [33, 25, 14, 14, 7, 7]
    }]
}






export class ChapterSixtyOne extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {""}
        </Subtopic>

        <TextHolder text="Our survey findings describe founders in SEA as a diverse bunch, coming from various academic backgrounds and work history. The key findings are: " />

        <TextHolder text=" • Many were repeat entrepreneurs which showed that serial entrepreneurship is on the rise in SEA. Once bitten by the startup bug, it is hard to go back being an employee." />
        <TextHolder text=" • Most founders teamed up with others and became co-founders in at least a team of two." />
        <TextHolder text=" • Many have raised up to $2 million to date, with a handful raising more." />
        <TextHolder text=" • Most are “young” founders, still in the pre-seed or seed stage of funding." />

        <TextHolder text=" • Their greatest challenge is fundraising, followed by finding relevant talent." />
        <TextHolder text=" • Founders and VCs were mostly educated abroad." />
        <TextHolder text=" • Most had a bachelor’s degree, while only a handful had PhDs" />
        <TextHolder text=" • About half of the founders had technology degrees, one-third received engineering degrees and the rest received business degrees." />

        <Highchartscomponent  chartsText="What is the single greatest challenge right now for your organization?"
         options={challenges} source="Source: 2018 State of SE Asian Tech Survey" />






          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/61.js